import { render } from "./MenuHidingBehavior.vue?vue&type=template&id=67a9c0e7"
import script from "./MenuHidingBehavior.vue?vue&type=script&lang=js"
export * from "./MenuHidingBehavior.vue?vue&type=script&lang=js"

import "./MenuHidingBehavior.vue?vue&type=style&index=0&id=67a9c0e7&lang=css"
script.render = render

export default script